/* eslint-disable camelcase */
import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { STRIPPING_TYPE_SECONDARY } from '../../utils/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData, modifyMetricDataByKey } from '../../utils/getMetrics';
import store from '../store';
import { listHydraulics } from './hydraulics';
import { enqueueSnackbar } from './snackbar';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
export const addNewStrippingRow = (unit) => (dispatch) => {
  const { stripping } = store.getState();
  const newData = [...stripping.data];
  const existUnit = { ...stripping.units };
  const nextId = newData.length - 1;
  const newRow = {
    from: '',
    to: '',
    tubular: 'Drillstring',
    speed: '',
    report_interval: unit === 'SI' ? 250 : 500,
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
    runNumber: newData.length + 1,
    filling_fluid_id: ''
  };
  newData.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_SUCCESS,
    payload: {
      data: newData,
      units: existUnit,
      paginatedElements: newData.length,
    },
  });
};
export const listStripping = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId
    }
  };
  return fetch
    .post('hydraulicsStrippings/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: stripping = [], units = {} } = data || [];
      const modifiedStrippingData = modifyMetricData(stripping, units?.inputs, currentUnit);
      const updatedResult = modifiedStrippingData.map((item, index) => {
        return {
          ...item,
          runNumber: index + 1,
        };
      });
      if (updatedResult?.length) {
        const updatedResultsWithTarget = updatedResult?.map((item) => {
          if (item?.target_data) {
            const targetData = modifyMetricData(
              [item.target_data],
              units.inputs.target_data,
              currentUnit
            );
            const targetRunsECDSpan = item.target_data?.ecd_span?.length
              ? modifyMetricData(
                item.target_data?.ecd_span,
                units.inputs.ecd_span,
                currentUnit
              )
              : [];
            const targetControlsTable = item.target_data?.controls_table?.length
              ? modifyMetricDataByKey(
                item.target_data?.controls_table,
                units.inputs.target_data?.controls_table,
                currentUnit,
                'parameter'
              )
              : [];
            targetData[0].ecd_span = targetRunsECDSpan;
            targetData[0].controls_table = targetControlsTable;
            if (!targetData[0]?.anchor_point) {
              targetData[0].anchor_point = 'None';
              targetData[0].target_ecd = null;
            }
            return { ...item, target_data: targetData[0] };
          }
          return item;
        });
        dispatch({
          type: REDUX_ACTIONS.STRIPPING_LIST_SUCCESS,
          payload: {
            ...data,
            data: updatedResultsWithTarget,
            paginatedElements: modifiedStrippingData.length,
            units: data.units
          },
        });
        return;
      }
      dispatch({
        type: REDUX_ACTIONS.STRIPPING_LIST_SUCCESS,
        payload: {
          ...data,
          data: updatedResult,
          paginatedElements: modifiedStrippingData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.STRIPPING_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
export const createStrippings = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_LOADING,
  });
  const { query, isStrippingResult } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    },
    input: payload.inputs
  };
  return fetch
    .post('hydraulicsStrippings/create', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Stripping Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listStripping(payload));
      if (isStrippingResult) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
export const updateStripping = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_LOADING,
  });
  const { query, isStrippingResult } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
    input: payload.inputs
  };
  return fetch
    .put('hydraulicsStrippings', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Stripping Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listStripping(payload));
      if (isStrippingResult) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
export const deleteStrippings = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_LOADING,
  });
  const { query, isStrippingResult } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
  };
  return fetch
    .deleteAction('hydraulicsStrippings', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Stripping Deleted Successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listStripping(payload));
      if (isStrippingResult) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
export const runStrippingAnalysis = (body, disableLoader, onClose) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LIST_LOADING,
  });
  dispatch({
    type: REDUX_ACTIONS.STRIPPING_LIST_LOADING,
  });
  const { runId, query } = body;
  const input = {
    input: {
      url: `/runs/stripping/${runId}`,
      method: 'POST',
    }
  };
  return fetch
    .post('premiumHydraulics/proxy', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Stripping Simulation Completed Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      disableLoader();
      onClose();
      dispatch({
        type: REDUX_ACTIONS.STRIPPING_SET_FALSE,
      });
      dispatch(listHydraulics(query));
    })
    .catch(async (error) => {
      disableLoader();
      dispatch({
        type: REDUX_ACTIONS.STRIPPING_SET_FALSE,
      });
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulics(query));
    });
};
export const downloadStrippingPDF = (body, printPreview, disableLoader) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_LOADING,
  });
  const payload = {
    inputs: body?.inputs,
    jobId: body?.jobId,
    runId: body?.runId,
    wellsInfoId: body?.wellsInfoId,
    type: body?.type,
    depth: body?.depth,
    axis_range: {
      x: body.xAxis,
      y: body.yAxis
    }
  };

  try {
    const result = await fetch.downloadPost('reports/stripping', payload);
    if (!result.ok) {
      throw result;
    }
    const blob = await result.blob();
    const fileName = `${body?.rigName}-${body?.wellName}-${body?.runName}-Stripping-Report.pdf`;
    if (printPreview) {
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
      dispatch({
        type: REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_IDLE,
      });
      disableLoader();
      return;
    }
    if (window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [{ description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } }],
        });
        const writableStream = await handle.createWritable();
        await writableStream.write(blob);
        await writableStream.close();
        dispatch(
          enqueueSnackbar(
            'File saved successfully!',
            'success',
            new Date().getTime() + Math.random()
          )
        );
        disableLoader();
      } catch (error) {
        if (error.name === 'AbortError' || error.name === 'NotAllowedError') {
          dispatch(
            enqueueSnackbar(
              'Download cancelled',
              'warning',
              new Date().getTime() + Math.random()
            )
          );
          disableLoader();
        } else {
          downloadFileDirectly(blob, fileName);
          disableLoader();
        }
      }
    } else {
      downloadFileDirectly(blob, fileName);
    }
    dispatch({
      type: REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_IDLE,
    });
  } catch (error) {
    const errorMessage = await parseError(error);
    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );
    dispatch({
      type: REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_ERROR,
    });
    disableLoader();
  }
};
const downloadFileDirectly = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
export const listStrippingResults = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    }
  };
  return fetch
    .post('hydraulicsStrippings/results/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: strippingData, units } = data;
      units.depth_points.bit_depth = units.depth_points.md;
      delete units.depth_points.md;
      const holeDepthUnit = units?.depths_summary?.hole_depth;
      const listData = strippingData?.results?.map((item) => {
        const { trip_data } = item.inputs || {};
        const modifiedTripData = modifyMetricData([trip_data], units?.inputs, currentUnit)[0];
        const secondaryFieldsSet = new Set();
        const modifiedResult = item.results.map((resultItem) => {
          const { casing_shoe, hole_depth, landing_point, ...restDepths } = resultItem.depths_summary || {};
          const modifiedBitDepth = modifyMetricData([resultItem], units?.depth_points, currentUnit)[0];

          const modifiedCasingShoe = modifyMetricData([casing_shoe], units?.depths_summary?.casing_shoe, currentUnit)[0];
          const modifiedHoleDepth = modifyMetricData([hole_depth], units?.depths_summary?.hole_depth, currentUnit)[0];
          const modifiedLandingPoint = modifyMetricData([landing_point], units?.depths_summary?.landing_point, currentUnit)[0];

          // Dynamically modify other keys
          const modifiedOtherDepths = {};
          for (const [key, value] of Object.entries(restDepths)) {
            const modifiedValue = modifyMetricData([value], units?.depths_summary?.hole_depth, currentUnit)[0];
            const transformedKey = key.replace(/_/g, ' ').toUpperCase();
            modifiedOtherDepths[transformedKey] = modifiedValue;
            secondaryFieldsSet.add(transformedKey);
            if (!units.depths_summary[transformedKey]) {
              units.depths_summary[transformedKey] = holeDepthUnit;
            }
          }

          return {
            ...resultItem,
            bit_depth: modifiedBitDepth.bit_depth,
            depths_summary: {
              casing_shoe: modifiedCasingShoe,
              hole_depth: modifiedHoleDepth,
              landing_point: modifiedLandingPoint,
              ...modifiedOtherDepths
            }
          };
        });

        const dynamicSecondaryFields = Array.from(secondaryFieldsSet).map((key) => ({
          label: key,
          key: '',
          field: key,
          labelValue: key
        }));

        return {
          ...item,
          results: modifiedResult,
          secondary_fields: [...STRIPPING_TYPE_SECONDARY, ...dynamicSecondaryFields],
          inputs: {
            ...item.inputs,
            trip_data: modifiedTripData
          }
        };
      });
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_SUCCESS,
        payload: {
          data: listData,
          paginatedElements: listData.length,
          units: data.units,
          ph_version: strippingData?.run_details_copy?.ph_version
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
